/**
 * Ссылка на адрес в 2ГИС.
 *
 * Поиск в 2ГИС идёт по ГОРОДУ того, кто смотрит: без подсказки улан-удэнский
 * адрес из Иркутска искался бы в Иркутске и не находился. Поэтому город
 * вписывается в ссылку сам — по названию в адресе, а если его нет, по
 * почтовому индексу. Незнакомый город — обычный поиск без города: 2ГИС
 * хотя бы попробует найти сам.
 *
 * Города — те, где есть клиники лаборатории (сверено с адресами филиалов
 * 22.09.2026); названия проверены на сайте 2ГИС. Сёла относятся к городу
 * своего края: Хомутово — Иркутск, Сотниково и Кижинга — Улан-Удэ.
 */

const ГОРОДА: { slug: string; признак: RegExp }[] = [
  { slug: 'ulanude', признак: /Улан-Удэ|Бурят|Иволгинск|Кижинг|^\s*67[01]\d{3}/i },
  { slug: 'yakutsk', признак: /Якутск|Саха|^\s*677\d{3}/i },
  { slug: 'bratsk', признак: /Братск/i },
  { slug: 'irkutsk', признак: /Иркутск|^\s*66[45]\d{3}/i },
];

export function twoGisLink(address: string): string {
  const город = ГОРОДА.find((g) => g.признак.test(address))?.slug;
  /* Индекс в начале 2ГИС только мешает: ищет он по улице и дому. */
  const запрос = encodeURIComponent(address.replace(/^\s*\d{6},?\s*/, '').trim());
  return город ? `https://2gis.ru/${город}/search/${запрос}` : `https://2gis.ru/search/${запрос}`;
}
